import React, { forwardRef, useState, useImperativeHandle } from "react";
import { Button, Text, Input, Checkbox, Link } from "@virkesborsen/ui-component-library";

const TermsStep = forwardRef(({ onNext },ref) => {
    const [termsSelected,setTermsSelected] = useState(false);
    useImperativeHandle(ref, () => ({
        validateAndReturn() {
            if (!termsSelected) {
                return { errors: true};
            }

            return {
                data: {
                    acceptTerms:termsSelected,
                    step:"treeform_accepted_terms"
                }
            };
        }
    }));
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                <Text variant="text-xl/leading-normal/normal" className="text-white">Vi värdesätter din integritet.</Text>
                <Text variant="text-base/leading-normal/normal" className="text-white">För att kunna hjälpa dig behöver du acceptera vår integritetspolicy och våra användarvillkor. Om du inte accepterar kan vi inte kontakta dig.</Text>
                <div>
                    <Checkbox
                        name="checkbox"
                        onClick={(val) => {setTermsSelected(val)}}
                    >
                        <Text variant="text-base/leading-normal/normal" className="text-white">Jag godkänner Treebulas <Link tw href="/terms" underline className="text-spring-yellow-500">integritetspolicy</Link> och <Link tw href="/privacy" underline className="text-spring-yellow-500"> användarvillkor.</Link> </Text>
                    </Checkbox>
                </div>


            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        tw
                        onClick={()=>onNext({data:{
                            acceptTerms:termsSelected,
                            step:"treeform_accepted_terms"
                        }})}
                        variant="quaternary"
                        fullWidth
                        disabled={!termsSelected}
                    >
                        Skicka
                    </Button>
                </div>
            </div>
        </div>
    )
});

export default TermsStep;